import moment from "moment";
import { Col, Container, Row } from "react-bootstrap";
// import pic from "../../../assets/images/home/compeny-logo.svg";
const url = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL;
// import handleViewport from "react-in-viewport";
import Image from "next/image";
import Link from "next/link";
import { decodeHTMLEntities, toWebp } from "../../../utils/common";
import styles from './style.module.scss'

const Feature = (props) => {
	const { data } = props;
	const inViewport = true;
	// const { forwardedRef, inViewport, data } = props;

	let articleData = data?.articles?.data;

	articleData &&
		articleData.map((data) => {
			const momentDate = moment(data.attributes.publish_at || data.attributes.createdAt);
			const formattedDate = momentDate.isValid() ? momentDate.format("MMMM Do, YYYY") : "Unknown Date";
			const ImageURL = url + data?.attributes?.image?.data?.attributes?.url;

			data.date = formattedDate;
			data.ImageURL = ImageURL;
			return data;
		});


	return (
		<section
			// ref={forwardedRef}
			className={`${styles['feature-new-section']} bg-one home-padding-new `}
		// style={{ minHeight: "858px" }}
		>
			{inViewport && (
				<Container className={styles['container']}>
					<Row>
						<Col lg={12}>
							<div className={styles['feature-heading-content']}>
								<h2 className="text-black">{decodeHTMLEntities(data.title)}</h2>
							</div>
						</Col>
						{articleData?.[0] && (
							<Col lg={5} md={6} sm={6}>
								<Link href={"/blog/" + articleData?.[0]?.attributes.slug}>
									<div className={styles['feature-card']}>
										<Image
											src={
												articleData?.[0]?.ImageURL
													? toWebp(`${articleData?.[0]?.ImageURL}`)
													: null
											}
											alt="article"
											height={670}
											width={1448}
											quality={100}
										// loading="eager"
										/>
										<div className={` ${styles['feature-card-content']}`}>
											<h3 className="text-medium font-semibold">{articleData?.[0]?.attributes?.title}</h3>

											<ul>
												<li>{articleData?.[0]?.attributes?.time_to_read} read</li>
												<li>{articleData?.[0]?.date}</li>
											</ul>
										</div>
									</div>
								</Link>
							</Col>
						)}
						{articleData?.[1] && (
							<Col lg={4} md={6} sm={6}>
								<Link href={"/blog/" + articleData?.[1]?.attributes.slug}>
									<div className={styles['feature-card']}>
										<Image
											src={
												articleData?.[1]?.ImageURL
													? toWebp(`${articleData?.[1]?.ImageURL}`)
													: null
											}
											alt="article"
											height={670}
											width={1448}
											quality={100}
										/>
										<div className={`${styles['feature-card-content']} ${styles['feature-top-content']}`}>
											<h3 className="text-medium font-semibold">{decodeHTMLEntities(articleData?.[1]?.attributes?.title)}</h3>
											<ul>
												<li>
													{articleData?.[1]?.attributes?.time_to_read} read{" "}
												</li>
												<li>{articleData?.[1]?.date}</li>
											</ul>
										</div>
									</div>
								</Link>
							</Col>
						)}

						<Col lg={3} md={12}>
							<Row>
								{articleData?.[2] && (
									<Col lg={12} md={6} sm={6}>
										<Link href={"/blog/" + articleData?.[2]?.attributes.slug}>
											<div className={`${styles['feature-card']} ${styles['feature-card-right']}`}>
												<Image
													src={
														articleData?.[2]?.ImageURL
															? toWebp(`${articleData?.[2]?.ImageURL}`)
															: null
													}
													alt="article"
													height={670}
													width={1448}
													quality={100}
												/>
												<div className={styles['feature-card-content']}>
													<h3 className="text-medium font-semibold">{decodeHTMLEntities(articleData?.[2]?.attributes?.title)}</h3>
												</div>
											</div>
										</Link>
									</Col>
								)}
								{articleData?.[3] && (
									<Col lg={12} md={6} sm={6}>
										<Link href={"/blog/" + articleData?.[3]?.attributes.slug}>
											<div className={`${styles['feature-card']} ${styles['feature-card-right']}`}>
												<Image
													src={
														articleData?.[3]?.ImageURL
															? toWebp(`${articleData?.[3]?.ImageURL}`)
															: null
													}
													alt="article"
													height={670}
													width={1448}
													quality={100}
												/>
												<div className={styles['feature-card-content']}>
													<h3 className="text-medium font-semibold">{decodeHTMLEntities(articleData?.[3]?.attributes?.title)}</h3>
												</div>
											</div>
										</Link>
									</Col>
								)}
							</Row>
						</Col>
					</Row>
				</Container>
			)}
		</section>
	);
};

// const FeatureViewportBlock = handleViewport(Feature);

export default Feature;
